import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzel = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel12'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel10'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">1000 Coins and 10 Bags</h1>
    
    <div class="text">
        <p>A dealer has 1000 coins and 10 bags. He has to divide the coins over the ten bags so that he can make any
            number of coins simply by handing over a few bags. How must divide his money into the ten bags?&nbsp;</p>
        <p><strong>Solution:</strong>&nbsp;</p>
        <p>The idea of filling coins in the powers of 2 can be get from the condition that was given the question that
            each bag can be given or not given, that is we are not allowed to open the bag and give some coins. So we
            can represent each bag as each place value which takes either the value of 0 or 1. For example if we have to
            give 7 coins then it is nothing but 0000000111 the last 3 digits of 1 represents that those 3 bags whose
            place values are 1,2,4 are to be given to give 7 coins. Remember that each bag should be either given or not
            given that means there are only 2 choices to us, which has similarity with the numbers in base 2 where each
            digit has only 2 values either 1 or 0.<br/>We can fill coins in the 10 bags in increasing order of 2^n where
            n varies from 0 – 8, filling the last bag with all remaining coins as follows:&nbsp;</p>
        <p>1 = 2^0 = 1&nbsp;</p>
        <p>2 = 2^1 = 2&nbsp;</p><br/>
        <div id="AP_G4GR_5"></div>
        
        <p>3 = 2^2 = 4&nbsp;</p>
        <p>4 = 2^3 = 8&nbsp;</p>
        <p>5 = 2^4 = 16&nbsp;</p>
        <p>6 = 2^5 = 32&nbsp;</p>
        <p>7 = 2^6 = 64&nbsp;</p>
        <p>8 = 2^7 = 128&nbsp;</p>
        <p>9 = 2^8 = 256&nbsp;</p>
        <p>10 = remaining coins = 489&nbsp;</p>
        <p>Now, the dealer can make any number of coins just by handing over the bags.&nbsp;</p>
        <p>As,&nbsp;<br/>number 0f coins needed = some bag 1 + some bag 2 + ….. + some bag
            n&nbsp;<br/>example:&nbsp;<br/>519 coins = bag 2 + bag 4 + bag 8 + bag 16 + bag 489&nbsp;</p>
        <p>Factorization algorithms other than powers of 2 are costly on computer systems. Please share any other
            information. Any person working on cryptography can share more details.&nbsp;</p>
        
    </div>
</article>
        </div>
    )
}

export default Puzel
